<mat-form-field *ngIf="config.useFilter">
    <mat-label>Filtrar</mat-label>
    <input matInput (keyup)="applyFilter($event)" />
</mat-form-field>

<mat-table [dataSource]="tableDataSource" matSort class="mat-elevation-z8">
    <ng-container *ngFor="let col of config.displayColumns" matColumnDef="{{ col.field }}">
        <mat-header-cell *matHeaderCellDef mat-sort-header [disabled]="!this.config.useSortable"
            [style.width]="col.width" [style.maxWidth]="col.width">
            {{ col.displayName | translate }}
        </mat-header-cell>

        <mat-cell *matCellDef="let element" [style.width]="col.width" [style.maxWidth]="col.width">
            <div [ngSwitch]="col.type">
                <div *ngSwitchCase="'currency'">
                    <ng-container *ngIf="col.hideCurrencySymbol; else withSymbol">
                        {{ element[col.field] | number:'1.2-2' }}
                    </ng-container>
                    <ng-template #withSymbol>
                        {{ element[col.field] | currency }}
                    </ng-template>
                </div>

                <div *ngSwitchCase="'date'">
                    {{ element[col.field] | date: config.dateformat }}
                </div>

                <div *ngSwitchCase="'action'">
                    <ng-container *ngFor="let lineAction of config.lineActions">
                        <button class="buttonAction" mat-icon-button color="{{ lineAction.color }}"
                            *ngIf="!lineAction.hidden || !lineAction.hidden(element)"
                            (click)="lineAction.action(element)"
                            placement="top" ngbTooltip="{{ lineAction.label }}" ngbTooltipClass="kt-tooltip"
                            [disabled]="lineAction.disabled ? !lineAction.disabled(element) : false">
                            <mat-icon>{{ lineAction.icon }}</mat-icon>
                        </button>
                    </ng-container>
                </div>

                <div *ngSwitchCase="'icon-done-done-all'">
                    <ng-container *ngIf="element[col.field]; else elseIconDoneDoneAll">
                        <mat-icon style="color: green">done_all</mat-icon>
                    </ng-container>
                    <ng-template #elseIconDoneDoneAll>
                        <mat-icon style="color: #ffa800">done</mat-icon>
                    </ng-template>
                </div>

                <div *ngSwitchCase="'icon-true-or-false'">
                    <ng-container *ngIf="element[col.field]; else elseIconTrueOrFalse">
                        <mat-icon style="color: green">done</mat-icon>
                    </ng-container>
                    <ng-template #elseIconTrueOrFalse>
                        <mat-icon style="color: red">remove</mat-icon>
                    </ng-template>
                </div>

                <div *ngSwitchCase="'style-with-action-currancy'">
                    <div [ngStyle]="col.style(element)" style="cursor: pointer" (click)="col.action(element)">
                        {{ element[col.field] | currency }}
                    </div>
                </div>

                <div *ngSwitchCase="'status'">
                    <span class="label label-lg label-inline" [ngClass]="{
                            'label-light-danger': element[col.field] == false,
                            'label-light-success': element[col.field] == true
                        }">{{ element[col.field] == true ? "Ativo" : "Inativo" }}</span>
                </div>

                <div *ngSwitchCase="'statusCard'">
                    <span class="label label-lg label-inline" [ngClass]="{
                            'label-light-danger': element[col.field] == 0,
                            'label-light-success': element[col.field] == 1,
                            'label-light-primary': element[col.field] != 0 && element[col.field] != 1
                        }">
                        {{
                        element[col.field] == 1 ? "Ativo" : element[col.field] == 0 ? "Inativo" : "Sem Contrato"
                        }}</span>
                </div>

                <div *ngSwitchCase="'messageTooltip'">
                    {{ processRetorn(element[col.field]) }}
                </div>

                <div *ngSwitchCase="'information'">

                    <ng-template #htmlContentTooltipInformation>
                        <div class="footerPreviewCustomDevoluiton">

                            <label class="form-text" for="accountingGroupName">
                                <strong>Mensagens</strong>
                            </label>
                            <div class="row" *ngFor="let item of element[col.field]">
                                <div class="col">
                                    <div class="form-group">
                                        <span class="form-text" id="accountingGroupName">{{ item }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </ng-template>

                    <mat-icon placement="right" class="iconInfo cursorCustom" triggers="mouseenter:mouseleave"
                        [autoClose]="true" [ngbTooltip]="htmlContentTooltipInformation">
                        info
                    </mat-icon>
                </div>

                <div *ngSwitchCase="'journalStatus'">
                    <span
                        class="label label-lg label-inline {{ element[col.field] == 'CreationError' || element[col.field] == 'ExportError' ? 'label-light-danger' :  element[col.field] == 'Success' ? 'label-light-success' : 'label-light-warning'}}">
                        {{col.translateKey + '.' + element[col.field] | translate}}
                    </span>
                </div>

                <div *ngSwitchDefault>

                    <div *ngIf="col.translateKey">
                        {{col.translateKey + '.' + element[col.field] | translate}}
                    </div>

                    <div *ngIf="!col.translateKey">
                        {{element[col.field] ? element[col.field] : '-'}}
                    </div>

                </div>

            </div>

        </mat-cell>

    </ng-container>

    <mat-header-row *matHeaderRowDef="cols"> </mat-header-row>

    <mat-row (click)="
            config.selection && config.selection.type === 'action' ? config.selection.action(row) : selectableLine(row)
        " *matRowDef="let row; columns: cols"
        [ngClass]="{ click: config.selection, selected: isSelected(row) && config.selection }">
    </mat-row>
</mat-table>

<mat-paginator [pageSizeOptions]="config.pageSize" showFirstLastButtons *ngIf="verifyUsePaginator()"
    (page)="pageEvent = changePage($event)" [length]="config.page.totalElements" [pageSizeOptions]="config.pageSize"
    [pageSize]="config.page.size" [pageIndex]="config.page.index"></mat-paginator>